<template>
  <card>
    <template #header>
      <div class="flex gap-2 items-center">
        <span :class="['size-2 rounded-full', medianTargetSalaryDifference <= 0 ? 'bg-green-500' : 'bg-red-500']"/>
        <a
          :href="route('budgets.show', budget.school)"
          class="leading-tight text-ellipsis overflow-hidden font-medium text-blue dark:text-white hover:text-blue dark:hover:text-blue-200 dark:text-white"
        >
          {{ heading || budget.school.name }}
        </a>
      </div>

      <budget-delete-modal v-slot="{ activator }" :school="budget.school">
        <l-button ref="deleteBudgetButton" class="hidden" @click="activator">
          Delete
        </l-button>
      </budget-delete-modal>

      <l-menu type="overflow">
        <l-menu-item :href="route('budgets.show', budget.school)">
          View budget
        </l-menu-item>

        <l-menu-item v-if="route().current() !== 'schools.costs'" :href="route('schools.costs', budget.school)">
          View school
        </l-menu-item>

        <l-menu-item @click="deleteBudget">
          Delete budget
        </l-menu-item>
      </l-menu>
    </template>

    <debt-projection :debt="debt" :finances="user.finances" :debt-service="budget.debt_service" :median-earnings="medianEarnings"/>
  </card>
</template>

<script setup>
import BudgetDeleteModal from "@/components/modals/BudgetDeleteModal.vue"
import Card from "@/components/cards/Card.vue"
import DebtProjection from "@/components/DebtProjection.vue"
import LButton from "@/components/buttons/LButton.vue"
import LMenu from "@/components/menus/LMenu.vue"
import LMenuItem from "@/components/menus/LMenuItem.vue"
import route from "ziggy-js"
import { computed, ref } from "vue"
import { useAuth } from "@/composables/useAuth"

const props = defineProps({
  budget: { type: Object },
  debt: { type: Object },
  medianEarnings: { type: Number },
  heading: { type: String },
})

const { user } = useAuth()

const medianTargetSalaryDifference = computed(() => Math.round((props.debt.target_salary / props.medianEarnings * 100) - 100))

const deleteBudgetButton = ref(null)

const deleteBudget = () => {
  deleteBudgetButton.value.$el.click()
}
</script>
